import mainEpics from './epics';
import reducer from './reducers';
import * as mainSelectors from './selectors';
import * as mainTypes from './types';

export { mainSelectors, mainTypes, mainEpics };

export default reducer;
